export default {
  title: 'Information du passager',
  form: {
    fields: {
      firstName: {
        label: 'Prénom',
        required: 'Prénom est requis',
      },
      lastName: {
        label: 'Nom',
        required: 'Nom est requis',
      },
      email: {
        label: 'Courriel',
        required: 'Courriel est requis',
      },
      phone: {
        label: 'Téléphone',
      },
    },
  },
};